import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var JiraSvg = function JiraSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2684FF",
    d: "m20.785 11.44-8.009-8.606L12 2 5.972 8.478 3.216 11.44a.835.835 0 0 0 0 1.12l5.507 5.918L12 22l6.028-6.478.094-.1 2.663-2.862a.835.835 0 0 0 0-1.12M12 14.957 9.249 12 12 9.043 14.751 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__a)",
    d: "M12 9.027C10.21 7.089 10.202 3.95 11.98 2L6 8.475 9.255 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__b)",
    d: "M14.742 12 12 14.962c.864.933 1.35 2.2 1.35 3.52S12.864 21.066 12 22l6-6.481z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 10.061,
    x2: 7.131,
    y1: 6.033,
    y2: 8.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 13.959,
    x2: 16.874,
    y1: 17.917,
    y2: 15.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  }))));
};
export var Jira = function Jira(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: JiraSvg
  }));
};